import { Icon, Popover, Typography } from '@fox/atoms';
import { useComponentClassContext } from '../component-class-context';
import { useComponentStyleContext } from '../component-style-context';
import { PAGE_TYPES } from '../page-types';
import { HeaderLinkProps, MenuItem } from './contracts';
import { HeaderLinkOverlay } from './render-children';

/**If we are a mega menu, we will display all children
 * If we are not a mega menu we will not display children for event/news pages
 * This way we can have some control over whether we show children
 */
export const shouldDisplayMenuMenuLinks = (input: { hasChildren: boolean; isMegaMenu: boolean; menuItem: MenuItem }) => {
	const { hasChildren, isMegaMenu, menuItem } = input;
	if (!hasChildren) return false;
	if (isMegaMenu || menuItem.type === PAGE_TYPES.PAGE_FOLDER || menuItem.type === PAGE_TYPES.BASIC_WITH_SUB_ITEMS) return true;

	return false;
};

export function ClickHeaderLink({ menuItem, maxRowsPerColumn, currentUrl, isMegaMenu, hideDropdownArrow }: HeaderLinkProps) {
	const hasChildren = menuItem.items?.length > 0;
	const { headerFont, headerFontColour, headerTextShadow, linkHoverColour, linkHoverUnderline } = useComponentStyleContext();
	const { headerClass } = useComponentClassContext();

	if (shouldDisplayMenuMenuLinks({ hasChildren, isMegaMenu, menuItem })) {
		return (
			<Popover
				noWrap
				trigger="click"
				overlay={
					<HeaderLinkOverlay
						menuItem={menuItem}
						maxRowsPerColumn={maxRowsPerColumn}
						currentUrl={currentUrl}
						isMegaMenu={isMegaMenu}
					/>
				}
			>
				<Typography
					variant="h3"
					className={`link-style ${headerClass}`}
					style={{
						...headerFont,
						...headerFontColour,
						...headerTextShadow,
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						cursor: 'pointer'
					}}
				>
					{menuItem.name}
					{!hideDropdownArrow ? <Icon iconName="KeyboardArrowDown" color="inherit" /> : null}
				</Typography>
			</Popover>
		);
	} else {
		return (
			<a
				style={{
					textDecoration: 'none',
					color: 'inherit',
					width: 'max-content',
					height: '100%',
					display: 'flex',
					alignItems: 'center',
					cursor: 'pointer'
				}}
				href={menuItem.url}
				target={menuItem.openInNewTab ? '_blank' : '_self'}
			>
				<Typography
					variant="h3"
					className={`link-style ${headerClass}`}
					style={{
						cursor: 'pointer',
						...headerFont,
						...headerFontColour,
						...headerTextShadow,
						...(menuItem.url === currentUrl ? { ...linkHoverColour, ...linkHoverUnderline } : {})
					}}
				>
					{menuItem.name}
				</Typography>
			</a>
		);
	}
}
